import {
  BUY_DEEPLINK,
  PRICE_ALERT_DEEPLINK,
} from '../../constants/sessionStorage';
import { storeInSessionStorage } from './sessionStorageHelper';

// openAlerts values that route to the My Alerts modal:
//   active            -> My Alerts list on the Active tab
//   expired|cancelled -> the Alert Entry (add-alert) form
const ALERT_DEEP_LINK_STATUSES = ['active', 'expired', 'cancelled'];

// Notification channel the deep link was delivered through. Recorded as the
// analytics `source` dimension on the buy_started/buy_submitted GTM events.
// Anything outside this set is ignored (source falls back to null downstream).
const DEEP_LINK_SOURCES = ['email', 'sms', 'text'];

export const PRICE_ALERT_DEEP_LINK_PARAMS = [
  'openAlerts',
  'openBuy',
  'productCode',
  'priceAlertUid',
  'accountUid',
  'source',
];

// Parses price-alert deep-link params out of a URL search string and, when
// present, stores the target in session storage (consumed by the auto-open
// effects in InfiniteHitsWithScrollToTop). Returns true if the search carried a
// price-alert deep link (whether or not a productCode was present), so callers
// can strip/replace the URL. Single source of truth for the deep-link URL
// contract — shared by BuyPage (direct navigation) and landingPageHelper
// (post-login redirect).
export const storePriceAlertDeepLinkFromSearch = (search) => {
  const params = new URLSearchParams(search);
  const productCode = params.get('productCode');
  const priceAlertUid = params.get('priceAlertUid');
  const accountUid = params.get('accountUid');
  const openAlerts = params.get('openAlerts');
  // Only store a recognised channel; anything else is dropped so the consumer
  // reports source: null rather than an arbitrary value.
  const rawSource = params.get('source');
  const source = DEEP_LINK_SOURCES.includes(rawSource) ? rawSource : undefined;

  if (ALERT_DEEP_LINK_STATUSES.includes(openAlerts)) {
    if (productCode) {
      storeInSessionStorage(PRICE_ALERT_DEEPLINK, {
        productCode,
        priceAlertUid,
        accountUid,
        status: openAlerts,
        ...(source && { source }),
      });
    }
    return true;
  }

  if (params.get('openBuy') === 'true') {
    if (productCode) {
      storeInSessionStorage(BUY_DEEPLINK, {
        productCode,
        priceAlertUid,
        accountUid,
        ...(source && { source }),
      });
    }
    return true;
  }

  return false;
};
